import { render, staticRenderFns } from "./cedisDefecto.vue?vue&type=template&id=4336054e&scoped=true"
import script from "./cedisDefecto.vue?vue&type=script&lang=js"
export * from "./cedisDefecto.vue?vue&type=script&lang=js"
import style0 from "./cedisDefecto.vue?vue&type=style&index=0&id=4336054e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4336054e",
  null
  
)

export default component.exports